import React from 'react';
import Mortal from 'react-mortal';

import AnimatedDiv from './styles';

export interface Props {
  show?: boolean;
  children?: JSX.Element;
  onClose?: () => void;
}

const AnimatedModal = ({ show, children, onClose = () => {} }: Props) => (
  <Mortal
    isOpened={show}
    onClose={onClose}
    motionStyle={(spring: any, isVisible: boolean) => ({
      opacity: spring(isVisible ? 1 : 0),
    })}
  >
    {(motion: any) => (
      <AnimatedDiv opacity={motion.opacity} isVisible={show}>
        {children}
      </AnimatedDiv>
    )}
  </Mortal>
);

export default AnimatedModal;
